import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Box,
  VStack,
  Heading,
  Text,
  Button,
  Alert,
  AlertIcon,
  Icon,
  useColorModeValue,
} from '@chakra-ui/react';
import {
  ArrowBackIcon,
  InfoIcon,
} from '@chakra-ui/icons';
import DocumentationLayout from '../../components/DocumentationLayout';

interface ComingSoonProps {
  title: string;
  description: string;
}

const ComingSoon: React.FC<ComingSoonProps> = ({ title, description }) => {
  const textSecondary = useColorModeValue('gray.600', 'gray.400');

  return (
    <DocumentationLayout
      title={title}
      description={description}
    >
      <VStack spacing={8} align="stretch">
        <Alert status="info" borderRadius="md">
          <AlertIcon />
          <Box>
            <Text fontWeight="semibold">Documentation Coming Soon</Text>
            <Text fontSize="sm">
              This documentation section is currently being developed. 
              Check back soon for comprehensive guides and tutorials.
            </Text>
          </Box>
        </Alert>

        <Box textAlign="center" py={12}>
          <Icon as={InfoIcon} boxSize={16} color="blue.300" mb={4} />
          <Heading size="lg" mb={4}>Content In Development</Heading>
          <Text color={textSecondary} mb={6} maxW="md" mx="auto">
            We're working hard to create comprehensive documentation for this topic. 
            In the meantime, you can explore other available documentation sections 
            or get started with the basics.
          </Text>
          
          <VStack spacing={4}>
            <Button
              as={RouterLink}
              to="/docs"
              colorScheme="blue"
              leftIcon={<ArrowBackIcon />}
            >
              Back to Documentation
            </Button>
            
            <Button
              as={RouterLink}
              to="/docs/first-problem"
              variant="outline"
            >
              Get Started Guide
            </Button>
          </VStack>
        </Box>
      </VStack>
    </DocumentationLayout>
  );
};

export default ComingSoon; 